import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const RegisterSuccess = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        '@media (max-width: 768px)': {
          alignItems: 'unset',
        },
      }}
    >
      <Box
        sx={{
          maxWidth: '450px',
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
        }}
      >
        <Typography variant='h1'>Registration Successful!</Typography>
        <Typography
          sx={{
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '17px',
            color: '#736977',
          }}
        >
          You've successfully completed the registration process. A confirmation
          email has been sent to the provided email address.
        </Typography>
        <Typography
          sx={{
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '17px',
            color: '#736977',
          }}
        >
          Please check your inbox and follow the instructions to confirm your
          registration. If you don't see the email, don't forget to check your
          spam folder.
        </Typography>
        <Button
          sx={{
            background: '#3293DB',
            color: '#fff',
            width: '100%',
            boxShadow: 'unset',
            fontSize: '14px',
            lineHeight: '17px',
          }}
          onClick={() => navigate('/')}
          type='submit'
          variant='contained'
        >
          Return to Log in
        </Button>
      </Box>
    </Box>
  );
};

export default RegisterSuccess;
